import React, { Component } from 'react';
import history from 'history/history';
import { Context } from 'context/context';
import segment from "segment";
import Activation from "dashboard/projects/project/Activation";
import Active from "dashboard/projects/project/Active";
import Processing from "dashboard/projects/project/Processing";
import Rejected from "dashboard/projects/project/Rejected";
import Error from "dashboard/projects/project/Error";
import Loading from "components/Loading";
import styles from "dashboard/projects/project/Project.module.scss";
import { isInFlight } from "data/statusPoll";

class Project extends Component {
    static contextType = Context;

    state = {
        selected: false,
        loading: false,
    };

    async componentDidMount() {
        segment.page('Project', {
            project: this.props.match.params.id
        });

        await this.fetchProject();
    }

    async componentDidUpdate(prevProps){
        if(this.props.match.params.id !== prevProps.match.params.id) {
            await this.fetchProject();
        }
    }

    // The project is read from the list by its id every time it is needed: the list is replaced by fetches, updates and polls, so an index
    // kept in state can point at another project after the list changes.
    currentIndex = () => this.context.projects.findIndex((project) => project.id === this.props.match.params.id);

    fetchProject = async () => {
        try {
            if(this.props.match.params.id){
                this.setState({
                    selected: true,
                    loading: true
                });

                const project = this.context.projects[this.currentIndex()];

                if(project.tunerStatus === "ready" || project.tunerStatus === "archived") {
                    await this.context.getAppliedWizards(this.props.match.params.id);
                }

                let fileName = "";
                if(project.originalFileName){
                    fileName = project.originalFileName.split("_");
                    fileName.shift();

                    if(fileName === "blob") fileName = "Demo File";
                }

                project.fileName = fileName;

                this.setState({
                    loading: false,
                    selected: true
                })
            } else {
                this.setState({
                    selected: false,
                    loading: false
                })
            }
        } catch {
            history.push("/projects");
        }
    };

    deleteProject = async () => {
        this.setState({
            deletingProject: true
        });

        const project = this.context.projects[this.currentIndex()];
        if(window.confirm("Are you sure you wish to delete this project? This action can not be undone.")){
            await segment.track('project_deleted', {
                application: 'dashboard',
                projectId: project.id,
                projectType: project.projectType === "DEMO" ? "demo" : "user"
            });
            await this.context.deleteProject(project.id);
            history.push('/projects')
        }

        this.setState({
            deletingProject: false
        });
    };

    render() {
        const projectIndex = this.currentIndex();
        const project = this.context.projects[projectIndex];
        if(this.state.selected && project){
            const panelProps = {...this.state, projectIndex, contextProject: projectIndex};
            return (
                <>


                    <div className={`${styles.project} highlightTertiary ${this.state.selected ? "bgSecondary" : null}`}>
                        {!this.state.loading ?
                            project.tunerStatus === "ready" || project.tunerStatus === "archived" ?
                                project.activated  ?
                                    <Active {...panelProps}
                                        fetchProject={this.fetchProject} 
                                        fetchProjects={this.props.fetchProjects} 
                                        deleteProject={this.deleteProject} 
                                        archiveState={this.archiveState} 
                                    />
                                :
                                    <Activation {...panelProps}
                                        fetchProject={this.fetchProject} 
                                        fetchProjects={this.props.fetchProjects} 
                                        deleteProject={this.deleteProject}
                                    />
                            :
                                isInFlight(project.tunerStatus) ?
                                    <Processing project={project} />
                                :
                                    project.tunerStatus === "error" || project.tunerStatus === "rejected" ?
                                        <Rejected {...panelProps}
                                            deleteProject={this.deleteProject}
                                        />
                                    :
                                        <Error {...panelProps}
                                           deleteProject={this.deleteProject}
                                        />
                            :
                            <Loading/>
                        }
                    </div>
                </>
            )
        } else {
            return false;
        }
    }
}

export default Project;
